<template>
    <account-apply
        :key="keys"
        :visible="accountVisible"
        @onClose="showAccountApply"
        :info="message"
    />

    <div class="login-box">
        <div class="header">
            <div class="w-content">
                <div class="logo fl"><a href="https://www.50yc.com" target="_blank">
                    <img src="../../assets/images/login_logo.png"></a></div>
                <div class="logo-yjy fl"><img src="../../assets/images/logo_yjy.png"></div>
            </div>
        </div>

        <div class="login-box" v-cloak id="app">
            <div class="w-content">
                <div class="login-input-box">
                    <h2>数据服务平台</h2>
                    <div class="input-box">
                        <div class="logo-input error" v-if="errMsg"><span><b>×</b></span><i class="error-cue">{{
                                errMsg
                            }}</i></div>
                        <div class="logo-input">
                            <span><u class="icon-name"></u></span>
                            <input type="text" :placeholder="USERNAME_PLACEHOLDER" v-model="userName" maxlength="20">
                        </div>
                        <div class="logo-input">
                            <span><u class="icon-pwd"></u></span>
                            <input type="password" :placeholder="PASSWORD_PLACEHOLDER" v-model="password" maxlength="20">
                        </div>

                        <div class="logo-code">
                          <div class="logo-input" style="flex: auto;">
                            <span><u class="icon-code"></u></span>
                            <input type="text" placeholder="请输入验证码" v-model="vcode" maxlength="6" style="width: 120px;" v-on:keyup.enter="signIn()">
                          </div>
                          <check-code
                            :userName="userName"
                            url="/api/getloginsmscode"
                          />
                        </div>

                        <div class="password-handle">
                            <a href="javascript:void(0);" @click="showAccountApply(true)">账号申请</a>
                            <!-- <a href="javascript:void(0);" @click="gotoModify(true)">修改密码</a> -->
                            <a href="javascript:void(0);" @click="gotoForget(true)">忘记密码</a>
                        </div>
                        <a href="javascript:void(0);" class="btn-login" v-on:click="signIn()" disabled="disabled">登
                            录</a>
                    </div>
                </div>
            </div>
            <!-- 验证码 -->
            <div class="GraphicVerificationCode-bg" v-show="showValidateWrapper">
                <div class="code-wrapper">
                    <div class="arrow">
                        <span></span>
                    </div>
                    <div class="validWay" id="__Verification"></div>
                </div>

            </div>
        </div>

        <div class="footer-four">
            <p>版权所有 © 四川物联亿达科技有限公司 2015-2020 保留一切权利</p>
            <p>
                <span>增值电信业务经营许可证：川B2-20180158 | 国家工信部备案号: 蜀ICP备12009201号-11 |</span>
                <a rel="nofollow" target="_blank"
                   href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51090302000118"><img
                    src="../../assets/images/备案图标.png">川公网安备 51090302000118号</a>
            </p>
            <p>
                本网站支持IE9以上浏览器，推荐您使用Google Chrome（<a rel="nofollow" href="https://www.google.cn/chrome/"
                                                                   target="_blank">下载链接</a>）或IE11（<a rel="nofollow"
                                                                                                          href="http://windows.microsoft.com/zh-cn/internet-explorer/ie-11-worldwide-languages/"
                                                                                                          target="_blank">下载链接</a>）进行浏览
            </p>
            <div class="img-box">
                <a rel="nofollow" href="http://www.12377.cn" target="_blank17"><img
                    alt="中国互联网违法和不良信息举报中心" dragover="true"
                    src="../../assets/images/zgjb.jpg"></a>
                <a rel="nofollow" href="http://www.scjb.gov.cn" target="_blank18"><img
                    alt="四川省互联网不良与违法信息举报中心" dragover="true"
                    src="../../assets/images/scjb.jpg"></a>
            </div>
        </div>
        <div class="loading" v-show="isShow">
            <div class="box">
                <div class="icon">
                    <div class="d1">
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="d1">
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                    </div>
                </div>
                <p>{{ tip }}</p>
            </div>
        </div>
        <div class="dialog-box" v-show="isOpen">
            <div class="dialog">
                <div class="dialog-head">
                    <h3>{{ title }}</h3>
                    <span class="dialog-close js-close" v-on:click="close()">
                <u class="iconfont icon-guanbi0"></u>
          </span>
                </div>
                <div class="dialog-content">
                    <div>
                        <u class="icon-cue">!</u>
                        <p><span>{{ msg }}</span>
                            {{ msg2 }}
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <div class="modify-password-box" v-if="isshowModify">
            <div class="modify-pwd-box">
                <p class="modify-text">密码修改</p>
                <div class="modify-box">
                    <div class="modify-error error" v-if="errMsg"><span><b>×</b></span><i class="error-cue">{{
                            errMsg
                        }}</i></div>
                    <div class="modify-input">
                        <span>登录账号：</span>
                        <input type="text" :placeholder="USERNAME_PLACEHOLDER" v-model="username" maxlength="20" disabled>
                    </div>
                    <div class="modify-input">
                        <span>登录密码：</span>
                        <input type="password" :placeholder="PASSWORD_PLACEHOLDER" v-model="password" maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>新密码：</span>
                        <input type="password" placeholder="请输入新密码" v-model="newPassword" maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>确认新密码：</span>
                        <input type="password" placeholder="请输入确认密码" v-model="comfirmPassword" maxlength="20">
                    </div>
                    <a href="javascript:void(0);" class="btn-modify" v-on:click="modify()" disabled="disabled">确 定</a>
                </div>
                <div class="close-user-box" @click="gotoModify(false)">×</div>
            </div>

        </div>

        <div class="modify-password-box" v-if="isshowForget">
            <div class="modify-pwd-box">
                <p class="modify-text">找回密码</p>
                <div class="modify-box">
                    <div class="modify-error error" v-if="forgeterrMsg"><span><b>×</b></span><i class="error-cue">{{
                            forgeterrMsg
                        }}</i></div>
                    <div class="modify-error suc" v-if="forgetsucMsg"><span><b>√</b></span><i class="error-cue">{{
                            forgetsucMsg
                        }}</i></div>
                    <div class="modify-input">
                        <span>用户名：</span>
                        <input type="text" :placeholder="USERNAME_PLACEHOLDER" v-model="mobile" maxlength="20" width="200">
                    </div>
                    <div class="modify-input">
                        <span>验证码：</span>
                        <div class="mobile-code">
                            <input type="text" placeholder="验证码" v-model="code" maxlength="20" style="width: 120px">
                            <check-code
                                style="margin-top: 0;margin-left: 20px; text-align: center;"
                                :userName="mobile"
                                url="/api/getresetpasswordsmscode"
                            />
                        </div>
                    </div>
                    <div class="modify-cue suc" v-if="sucMsg"><span @click="hideSucCue()"><b>×</b></span><i>{{
                            sucMsg
                        }}</i></div>
                    <div class="modify-input">
                        <span>新密码：</span>
                        <input type="password" :placeholder="NEW_PASSWORD_PLACEHOLDER" v-model="newPassword" maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>确认新密码：</span>
                        <input type="password" :placeholder="NEW_PASSWORD_CONFIRM_PLACEHOLDER" v-model="comfirmPassword" maxlength="20">
                    </div>
                    <a href="javascript:void(0);" class="btn-modify" v-on:click="reset()" disabled="disabled">确 定</a>
                </div>
                <div class="close-user-box" @click="gotoForget(false)">×</div>
            </div>
        </div>
    </div>
</template>
<script>
import {reactive, toRefs, ref, onMounted, watch} from 'vue'
import $ from 'jquery';
import {token} from './js/drag.js';
import request from '@/service/request'
import {useRouter} from 'vue-router'
import accountApply from './components/accountApply.vue'
import {getGlobalConfig, getClientHeadData} from "@/service/api";
import {analysisTime} from "@/tool/public";
import CheckCode from "@/view/login/components/checkCode.vue";

export default {
    components:{
      CheckCode,
      accountApply
    },
    

    setup() {

        let router = useRouter();
        let accountVisible = ref(false);

        let data = reactive({
            USERNAME_PLACEHOLDER: "请输入用户名",
            PASSWORD_PLACEHOLDER: "请输入密码",
            NEW_PASSWORD_PLACEHOLDER: "请输入新密码",
            NEW_PASSWORD_CONFIRM_PLACEHOLDER: "请输入确认密码",
            userName: '',
            password: '',
            errMsg: '',
            disabled: false,
            showValidateWrapper: false,
            isOpen: false,
            title: '',
            msg: '',
            msg2: '',
            isShow: false,
            tip: '',
            newPassword: "",
            comfirmPassword: "",
            mobile: '',
            code: '',
            sucMsg: '',
            forgeterrMsg: '',
            forgetsucMsg: '',
            vcode: '',
            keys: 0
        })
        let isshowModify = ref(false);
        let isshowForget = ref(false);

        function show(tip) {
            data.isShow = true;
            data.tip = tip || '加载中...';
        }

        function hide() {
            data.isShow = false;
        }

        function open(obj) {
            data.isOpen = true;
            data.title = obj.title || '提示';
            data.msg = obj.msg;
            data.msg2 = obj.msg2 || '';
        }

        function close() {
            data.isOpen = false;
        }

        function refrushSlideCode() {
            $("#__Verification").slide("300*200", function (ret, desc) {
                if (!ret) {
                    openDialog(desc);
                    return;
                }
                setTimeout(() => {
                    loginPost();
                }, 50);
            });
        }

      const getInfo = async () => {
        let {data} = await request({
          url: getGlobalConfig
        })
        if (data.latestQuarter) {
          localStorage.setItem('time', analysisTime(data.latestQuarter))
          localStorage.setItem('mapTime', data.latestQuarter)
          localStorage.setItem('cityList', JSON.stringify(data.cityList || []))
        }
      }

        function signIn() {
            data.disabled = true;
            if (!data.userName) {
                data.errMsg = '请输入用户名';
                data.disabled = false;
                return;
            }
            if (!data.password) {
                data.errMsg = '请输入密码';
                data.disabled = false;
                return;
            }

          if (!data.vcode) {
            data.errMsg = '请输入验证码';
            data.disabled = false;
            return;
          }

            data.showValidateWrapper = true;
            
        }

        async function getUserInfo() {
            let { data } = await request({
                url: getClientHeadData,
                data: {
                    filterateaear: false
                }
            })

            localStorage.setItem("phone", data.phoneNumber || '无');
            localStorage.setItem("email", data.email || '无');
            localStorage.setItem("companyName", data.companyName || '无');
            // let start = data.startTime.substr(0,10);
            localStorage.setItem("startTime", data.startTime || '');
            // let end = data.endTime.substr(0,10);
            localStorage.setItem("endTime", data.endTime || '');
        
        }
        function loginPost() {
            if (data.userName && data.password && token == '') {
                data.showValidateWrapper = true;
                return;
            } else {
                data.showValidateWrapper = false;
            }

            show('登录中...');

            $.ajax({
                url: process.env.VUE_APP_BASE_API + "/api/login",
                method: "post",
                dataType: "json",
                contentType: "application/json",
                data: `{"username":"${data.userName}","password":"${data.password}", "vcode":"${data.vcode}"}`,
                async success(res) {
                    hide();
                    data.disabled = false;
                    refrushSlideCode();
                    if (!res.token) {
                        openDialog(res.msg);
                        return;
                    }
                    console.log('4577777777777777778888888888878778878787878');
                    console.log(res);
                    console.log('4577777777777777778888888888878778878787878');
                    
                    localStorage.setItem("token", res.token);
                    localStorage.setItem("roleName", res.roleName);
                    localStorage.setItem("userName", res.userName);
                    

                    await getInfo();
                    getUserInfo()
                    router.replace({path: "/home/index"});
                }
            })
        }

        function openDialog(message) {
            if (!message) {
                open({msg: '服务器异常'});
                return;
            }

            if (message.indexOf('|') !== -1) {

                var msg = message.split('|');
                var errCode = msg[0];
                var errMsg = msg[1];
                var errMsg2 = '';
                switch (errCode) {
                    case "308":
                        errMsg2 = "如有疑问，请联系4008-567-150";
                        break;
                    case "322":
                        errMsg2 = "购买数据服务请咨询4008-567-150";
                        break;
                    default:
                        break;
                }
                open({msg: errMsg, msg2: errMsg2});
            } else {
                open({msg: message});
            }
        }

        function gotoModify(flag) {
            isshowModify.value = flag;
        }

        async function modify() {
            data.disabled = true;
            if (!data.password) {
                data.errMsg = '请输入密码';
                data.disabled = false;
                return;
            }
            if (!data.newPassword) {
                data.errMsg = '请输入新密码';
                data.disabled = false;
                return;
            }
            if (!data.comfirmPassword) {
                data.errMsg = '请输入确认密码';
                data.disabled = false;
                return;
            }
            if (data.newPassword != data.comfirmPassword) {
                data.errMsg = '输入的新密码和确认密码不一致';
                data.disabled = false;
                return;
            }

            try {
                let result = await request({
                    url: `/system/user/profile/updatePwd?oldPassword=${data.password}&newPassword=${data.newPassword}`,
                    method:'put'
                })
                localStorage.removeItem("token");
                localStorage.removeItem("roleName");
                localStorage.removeItem("userName");
                location.href = "/login";
            } catch (e) {
                data.errMsg = e.data.msg;
                data.disabled = false;
            } finally {
                data.disabled = false;
            }
        }

        function gotoForget(flag) {
            isshowForget.value = flag;
        }

        async function reset() {
            data.disabled = true;
            // if (!data.password) {
            //     data.forgeterrMsg = '请输入密码';
            //     data.disabled = false;
            //     return;
            // }
            if (!data.newPassword) {
                data.forgeterrMsg = '请输入新密码';
                data.disabled = false;
                return;
            }
            if (!data.comfirmPassword) {
                data.forgeterrMsg = '请输入确认密码';
                data.disabled = false;
                return;
            }
            if (data.newPassword !== data.comfirmPassword) {
                data.forgeterrMsg = '输入的新密码和确认密码不一致';
                data.disabled = false;
                return;
            }
            data.forgeterrMsg = ''
              let result = await request({
                  url: "/client/user/resetpassword",
                  method: 'put',
                  data: {
                      code: data.code,
                      userName: data.mobile,
                      newPassword: data.newPassword,
                  }
              })
            let {code, msg} = result;
            if(code === 200){
              this.forgetsucMsg = msg;
              setTimeout(() => {
                this.forgetsucMsg = ''
                this.isshowForget = false;
                localStorage.removeItem("token");
                localStorage.removeItem("roleName");
                localStorage.removeItem("userName");

                location.href = "/login";
              }, 3000)
            }else{
              this.forgeterrMsg = msg;
              setTimeout(() => {
                this.forgeterrMsg = ''
              }, 3000)
            }
        }

        async function getCode() {
            data.disabled = true;
            if (!data.mobile) {
                data.forgeterrMsg = '请输入用户名';
                data.disabled = false;
                return;
            }
            try {
                let result = await request({
                    url: `/api/getresetpasswordsmscode/${data.mobile}`
                })
                data.forgeterrMsg = ''
                data.sucMsg = result.data.msg
            } catch (e) {
                data.sucMsg = ''
                data.forgeterrMsg = e.data.msg;
                data.disabled = false;
            } finally {
                data.disabled = false;
            }
        }

        watch(
            //数据源,getter形式
            () => data.forgeterrMsg,
            // 回调函数 callback
            (newValue, oldValue) => {
                if (newValue) {
                    setTimeout(() => {
                        data.forgeterrMsg = '';
                    }, 5000)
                }
            }
        )

        function hideSucCue() {
            data.sucMsg = '';
        }

        onMounted(() => {
            refrushSlideCode();
            $('body').on('click', '.drag-shut', function () {
                data.showValidateWrapper = false;
            })
        })

        const showAccountApply = (v) => {
            console.log('656565656565');
            data.keys += 1
          console.log(v);
          accountVisible.value = v
          const message = ref({
  name: '',
  telephone: '',
  code: '',
  email: '',
  position: ''
});

        }

        return {
            ...toRefs(data),
            showAccountApply,
            accountVisible,
            show,
            hide,
            open,
            close,
            refrushSlideCode,
            signIn,
            loginPost,
            openDialog,
            isshowModify,
            gotoModify,
            isshowForget,
            gotoForget,
            modify,
            reset,
            getCode,
            hideSucCue,
        }
    }
}
</script>
<style lang="less">
@import '../../assets/css/layout.css';
@import '../../assets/css/login.css';
</style>